
<div class="modal-content modal-content-width border-all-10px-modal">
  <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


    <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
      <div class="row">
        <div class="col-md-8">
          Doctor List
        </div>
        <div class="col-md-4">
          <button type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>




    </div>

    <div class="modal-body padding-top-0px counselling-modal">


      <div class="row">
        <div class="modcolumn1 padding-right-5px">
          <div class="col-md-12">

            <div class="row margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px" *ngIf="SelectedPatientFormattedCode">
              <div class="col-md-10 margin-top-5px margin-bottom-5px bk-lt-gray">

                <div class="row">

                  <div class="col-md-12">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2">{{SelectedPatientFormattedCode.DisplayName}}</label>
                    </div>

                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f3">{{SelectedPatientFormattedCode.FormattedCode}}</label>
                    </div>

                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f3">{{SelectedPatientFormattedCode.Gender}}/{{SelectedPatientFormattedCode.Age}}</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-15px">
              <div class="col-md-10 margin-top-5px margin-bottom-5px bk-color-lavender">

                <div class="row">

                  <div class="col-md-12">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f3">Prescribing Doctor</label>
                    </div>

                    <div class="row margin-left-0px" *ngFor="let l of CurrentPrescribingDoctor">
                      <label class="margin-bottom-0px f2">{{l.DoctorName}}</label>
                    </div>

                    <div class="row margin-left-0px" *ngFor="let l of CurrentPrescribingDoctor">
                      <label class="margin-bottom-0px f3">{{l.Designation}}</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

            <div class="row margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-15px">
              <div class="col-md-10 margin-top-5px margin-bottom-5px bk-color-aliceblue">

                <div class="row">

                  <div class="col-md-12">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f3">Referring Doctor</label>
                    </div>

                    <div class="row margin-left-0px" *ngFor="let l of CurrentReferringDoctor">
                      <label class="margin-bottom-0px f2">{{l.DoctorName}}</label>
                    </div>

                    <div class="row margin-left-0px" *ngFor="let l of CurrentReferringDoctor">
                      <label class="margin-bottom-0px f3">{{l.Designation}}</label>
                    </div>

                  </div>

                </div>






              </div>
            </div>

          </div>
        </div>
        <div class="modcolumn2">
          <div class="col-md-12">

            <div class="row margin-top10px nav-link-hand margin-left-0px margin-right-0px">


              <label class="wh-header font-weight-normal border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px">
                Prescribing Doctor
              </label>


            </div>
            <div class="row margin-top-10 margin-bottom-10px margin-left-0px">
              <div class="col-md-10 padding-left-0px">
                <search-list  [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->
              </div>



            </div>
            <!--<div class="chatsd product-chart-wrapper product-chat-height-557 agreement-chart-wrapper scroll padding-lrt ">
            </div>-->
              <div class="row rowfor-3" *ngFor="let l of pdata">
                <div class="col-md-10 border-bottom padding-bottom-10px padding-top-10px">
                  <div class="row">
                    <div class="col-md-2 padding-top-5px padding-right-0px">
                      <button type="button"
                              class="btn  btn-sm plus-button " id="FileUpload"
                              (click)="AddRowPrescriber(l)"
                              name="upload">
                        <i class="fas fa-plus font-size-11p"></i>
                      </button>
                    </div>
                    <div class="col-md-10 padding-left-10px">
                      <div class="row margin-left-0px">
                        <label class="margin-bottom-0px f2">{{l.Prefix}}{{l.DisplayName}}</label>
                      </div>
                      <div class="row margin-left-0px">
                        <label class="margin-bottom-0px f3">{{l.Specialty}}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            
            </div>
          </div>
        <div class="modcolumn3">
          <div class="col-md-12">

            <div class="row margin-top10px nav-link-hand margin-left-0px margin-right-0px">


              <label class="wh-header font-weight-normal border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px">
                Referral Doctor
              </label>


            </div>
            <div class="row margin-top-10 margin-bottom-10px margin-left-0px">
              <div class="col-md-10 padding-left-0px">
                <search-list  [hideTitle]="1" (change)="criteriaChange1($event)"></search-list>
                <!--<input type="text" class="form-control" placeholder="Find Referral Doctor">-->

              </div>



            </div>

            <div class="row rowfor-4" *ngFor="let l of pdata1">
              <div class="col-md-10 border-bottom padding-bottom-10px padding-top-10px">
                <div class="row">
                  <div class="col-md-2 padding-top-5px padding-right-0px">
                    <button type="button"
                            class="btn  btn-sm plus-button " id="FileUpload"
                            (click)="AddRowReferral(l)"
                            name="upload">
                      <i class="fas fa-plus font-size-11p"></i>
                    </button>
                  </div>
                  <div class="col-md-10 padding-left-10px">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f2">{{l.Prefix}}{{l.DisplayName}}</label>
                    </div>
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px f3">{{l.Specialty}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>


    </div>
    <div class="modal-footer padding-top-10px padding-bottom-10px">

      <!--<button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>-->
      <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px" (click)="activeModal.close('Close click')">Cancel</button>
      <button type="submit" class="btn actions-btn-prime float-right font-size-13px" (click)="Data()">Proceed</button>
    </div>

  </div>
</div>
